import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { auth } from '../firebase'

export default class ForgotPassword extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: 'rohitxyzenator@gmail.com',
            error: null,
            valid: false,
            success: false,
            working: false
        };
    }
    async onForgotPassword() {

        if (this.state.working) {
            return;
        }
        const isEmailValid = auth.validateEmail(this.state.email);
        if (!isEmailValid) {

            this.setState({ success: false, valid: isEmailValid, error: "Please enter a valid email address.", working: false })
            return;
        }
        this.setState({ valid: false, success: false, working: true });
        await auth.doPasswordReset(this.state.email);
        this.setState({ valid: true, success: true, working: false });
    };

    handleEmailChange(e) {

        this.setState({
            email: e.target.value
        });
    };

    render() {

        return (
            <section class="hero is-fullheight is-light">
                <div class="hero-body">
                    <div class="container">
                        <div class="column is-4 is-offset-4">
                            <div class="box">
                                <div class='content'>
                                    <h1 class="title has-text-centered">
                                        Forgot Password
                                    </h1>
                                    Enter your Email and we will send you an email with instructions on how to reset your password.
                                    </div>
                                <form>
                                    <div class="field">
                                        <div class="control">
                                            <input
                                                class="input is-medium"
                                                type="email"
                                                placeholder="Your Email"
                                                autofocus=""
                                                value={this.state.email}
                                                onChange={this.handleEmailChange.bind(this)} />
                                        </div>
                                    </div>
                                    {this.state.success === true && <div className="notification is-success">
                                        <i class="fa fa-check-circle" aria-hidden="true" style={{ marginRight: 10 }}></i>Password reset instructions have been sent to your email.
                                    </div>}
                                    {this.state.error && this.state.error.length > 0 && <div className="notification is-danger">
                                        <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ marginRight: 10 }}></i> {this.state.error}
                                    </div>}
                                    <a class={"button is-block is-info is-medium" + (this.state.working ? " is-loading":"") } style={{ marginTop: 10 }} onClick={this.onForgotPassword.bind(this)}>Send Reset Link</a>
                                </form>

                                <div style={{ marginTop: 10 }}>
                                    <Link to='/login' class="button is-white is-block">Back to login</Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/forgot-password.js